// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"3b3926b8","1219":"3a1cb715","2404":"94bad5bb","2495":"94bad5bb","8440":"94bad5bb"}[chunkId] + ".chunk.css";
};